import { Button } from 'components/Button/Button';
import type { CmsApiPagePost } from 'modules/cms/api/types/CmsApiPage';
import { getContentLocaleUrl } from 'modules/cms/helpers/getContentLocaleUrl';
import { showModal } from 'zustand-stores/modalStore';

export function ShareButton({ content }: { content: CmsApiPagePost }) {
  const shareUrl = getContentLocaleUrl({ content }) as Record<
    UserLocale,
    string
  >;
  const handleShare = () => {
    showModal('SHARE_LISTING', {
      listingType: 'URL',
      messageOverride: getText('Check out this article'),
      shareUrl,
    });
  };
  return (
    <Button
      type="button"
      onClick={handleShare}
      data-qa-id="social-share-button"
      variant="secondary"
      icon={{ type: 'normalized', name: 'share' }}
    >
      {getText('Share')}
    </Button>
  );
}
